// extracted by mini-css-extract-plugin
export default {"CenteredLayout":"centeredLayout_CenteredLayout__pHc2M"};